import profile from '../../Assets/Images/Artists/03/profile_hidden.jpg'
import artIsObjImg1 from '../../Assets/Images/Artists/03/projects/01/1.jpg'
import artIsObjImg2 from '../../Assets/Images/Artists/03/projects/01/2.jpg'
import artIsObjImg3 from '../../Assets/Images/Artists/03/projects/01/3.jpg'
import artIsObjImg4 from '../../Assets/Images/Artists/03/projects/01/4.jpg'

const artisObjImages = [
  artIsObjImg1,
  artIsObjImg2,
  artIsObjImg3,
  artIsObjImg4
]

const project1 = {
  title: 'Art is Object',
  year: 2017,
  content: [
    {
      type: 'image',
      images: [...artisObjImages]
    },
  ]
}

const projects = [
  project1
]

const user = {
  username: 'srrnt',
  name: 'Serranito C.',
  url: 'https://www.behance.net/serranit',
  avatar: profile,
  seen: false,
  anonymous: true,
  projects: projects
}

export default user



// WEBPACK FOOTER //
// ./src/Data/Users/srrnt.js